import { FC } from 'react';
import styles from '@/components/blocks/BottomButtonsBlock/BottomButtonsBlock.module.scss';
import { BottomButtonsBlockPropsIF } from '@/components/blocks/BottomButtonsBlock/BottomButtonsBlock.types';

const BottomButtonsBlock: FC<BottomButtonsBlockPropsIF> = ({
    className = '',
    children,
    position = 'fixed',
}) => (
    <div
        className={`flcol flc gapButton ${styles.bottomButtonsBlockWrapper} ${className} ${styles[position]}`}
    >
        {children}
    </div>
);

export default BottomButtonsBlock;
